import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_7 = { class: "table-responsive" };
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_9 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
};
const _hoisted_10 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_11 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_12 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_13 = { key: 0 };
const _hoisted_14 = {
    colspan: "4",
    class: "text-center py-4"
};
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-capitalize" };
const _hoisted_16 = { class: "d-flex align-items-center text-capitalize" };
const _hoisted_17 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" };
const _hoisted_18 = ["onClick"];
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_20 = ["src"];
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" };
const _hoisted_24 = { class: "dropdown" };
const _hoisted_25 = { class: "dropdown-menu" };
const _hoisted_26 = ["onClick"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { key: 2 };
const _hoisted_29 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" };
const _hoisted_30 = { class: "mb-0 text-paragraph" };
const _hoisted_31 = { class: "mt-15 mt-md-0" };
const _hoisted_32 = { class: "pagination mb-0" };
const _hoisted_33 = ["onClick"];
const _hoisted_34 = { class: "modal-header" };
const _hoisted_35 = { class: "modal-title" };
const _hoisted_36 = { class: "modal-body" };
const _hoisted_37 = { class: "form-group mb-3" };
const _hoisted_38 = { class: "form-label" };
const _hoisted_39 = ["placeholder"];
const _hoisted_40 = { class: "form-text" };
const _hoisted_41 = { class: "form-group mb-3" };
const _hoisted_42 = { class: "form-label" };
const _hoisted_43 = { class: "row" };
const _hoisted_44 = { class: "col-12 col-md-6 mb-2" };
const _hoisted_45 = { class: "col-12 col-md-6 mb-2" };
const _hoisted_46 = { class: "col-12 col-md-6 mb-2" };
const _hoisted_47 = { class: "col-12 col-md-6 mb-2" };
const _hoisted_48 = { class: "form-group mb-3" };
const _hoisted_49 = { class: "form-label" };
const _hoisted_50 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_51 = { class: "image-preview-container" };
const _hoisted_52 = ["src"];
const _hoisted_53 = { class: "image-input-tabs" };
const _hoisted_54 = {
    class: "nav nav-tabs mb-3",
    role: "tablist"
};
const _hoisted_55 = {
    key: 0,
    class: "tab-content"
};
const _hoisted_56 = {
    key: 1,
    class: "tab-content"
};
const _hoisted_57 = { class: "modal-footer" };
const _hoisted_58 = ["disabled"];
const _hoisted_59 = ["disabled"];
const _hoisted_60 = {
    key: 1,
    class: "fas fa-save me-2"
};
const _hoisted_61 = {
    class: "modal fade",
    id: "confirmModal",
    tabindex: "-1",
    "aria-labelledby": "confirmModalLabel",
    "aria-hidden": "true"
};
const _hoisted_62 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_63 = { class: "modal-content" };
const _hoisted_64 = { class: "modal-footer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.gotoCreate && _ctx.gotoCreate(...args))),
                        class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                        type: "button"
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('lists.addIngredientBase')) + " ", 1),
                        _cache[28] || (_cache[28] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("form", {
                        class: "search-box position-relative me-15",
                        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"]))
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchQuery) = $event)),
                            type: "text",
                            class: "form-control shadow-none text-black rounded-0 border-0",
                            placeholder: _ctx.$t('lists.searchIngredientBase'),
                            onInput: _cache[2] || (_cache[2] = ($event) => (_ctx.currentPage = 1))
                        }, null, 40, _hoisted_5), [
                            [_vModelText, _ctx.searchQuery]
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("button", {
                            type: "submit",
                            class: "bg-transparent text-primary transition p-0 border-0"
                        }, [
                            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                        ], -1))
                    ], 32)
                ])
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('lists.id')), 1),
                                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('lists.icon')), 1),
                                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('lists.name')), 1),
                                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('lists.createdAt')), 1),
                                _cache[30] || (_cache[30] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                                }, null, -1))
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                                    _createElementVNode("td", _hoisted_14, [
                                        _createVNode(_component_LoaderComponent)
                                    ])
                                ]))
                                : (!_ctx.isLoading && _ctx.allIngredientsBase.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.allIngredientsBase, (ingredient, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: ingredient.id
                                        }, [
                                            _createElementVNode("th", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "form-check mb-0 text-capitalize" }, [
                                                        _createElementVNode("input", {
                                                            class: "form-check-input shadow-none",
                                                            type: "checkbox"
                                                        })
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_17, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: ($event) => (_ctx.selectForDetail(ingredient))
                                                        }, _toDisplayString(index + 1) + " - " + _toDisplayString(_ctx.getShortUuid(ingredient.id)), 9, _hoisted_18)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_19, [
                                                _createElementVNode("img", {
                                                    src: ingredient.image_url ||
                                                        require('@/assets/images/icon/jpg.png'),
                                                    class: "rounded-circle me-8",
                                                    width: "24",
                                                    height: "24"
                                                }, null, 8, _hoisted_20)
                                            ]),
                                            _createElementVNode("td", _hoisted_21, _toDisplayString(ingredient.name), 1),
                                            _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.convertDateCreate(ingredient.created_at)), 1),
                                            _createElementVNode("td", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    _cache[34] || (_cache[34] = _createElementVNode("button", {
                                                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                        type: "button",
                                                        "data-bs-toggle": "dropdown",
                                                        "aria-expanded": "false"
                                                    }, [
                                                        _createElementVNode("i", { class: "flaticon-dots" })
                                                    ], -1)),
                                                    _createElementVNode("ul", _hoisted_25, [
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDetail(ingredient))
                                                            }, [...(_cache[32] || (_cache[32] = [
                                                                    _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                                                    _createTextVNode(" Modifier", -1)
                                                                ]))], 8, _hoisted_26)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                "data-bs-toggle": "modal",
                                                                "data-bs-target": "#confirmModal",
                                                                href: "#",
                                                                onClick: ($event) => (_ctx.prepareDelete(ingredient))
                                                            }, [...(_cache[33] || (_cache[33] = [
                                                                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                                                    _createTextVNode(" Supprimer", -1)
                                                                ]))], 8, _hoisted_27)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                    : (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                                        _createVNode(_component_EmptyTable, {
                                            message: "Aucun ingrédient de base pour le moment",
                                            colspan: 4,
                                            textClass: "text-muted"
                                        })
                                    ]))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.paginationInfo), 1),
                    _createElementVNode("nav", _hoisted_31, [
                        _createElementVNode("ul", _hoisted_32, [
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Previous",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
                                }, [...(_cache[35] || (_cache[35] = [
                                        _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                    ]))])
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatePageNumbers(), (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: page,
                                    class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                                }, [
                                    _createElementVNode("a", {
                                        class: "page-link",
                                        href: "#",
                                        onClick: _withModifiers(($event) => (_ctx.changePage(page)), ["prevent"])
                                    }, _toDisplayString(page), 9, _hoisted_33)
                                ], 2));
                            }), 128)),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Next",
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
                                }, [...(_cache[36] || (_cache[36] = [
                                        _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                    ]))])
                            ], 2)
                        ])
                    ])
                ])
            ])
        ]),
        (_ctx.showModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "modal-overlay",
                onClick: _cache[26] || (_cache[26] =
                    //@ts-ignore
                    (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, [
                _createElementVNode("div", {
                    class: "modal-container",
                    onClick: _cache[25] || (_cache[25] = _withModifiers(() => { }, ["stop"]))
                }, [
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("h5", _hoisted_35, [
                            _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fas fa-plus-circle me-2 text-success" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.isEditing
                                ? _ctx.$t('ingredientBase.editIngredientBase')
                                : _ctx.$t('ingredientBase.addIngredientBase')), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close-modal",
                            onClick: _cache[6] || (_cache[6] =
                                //@ts-ignore
                                (...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                            "aria-label": "Close"
                        }, [...(_cache[38] || (_cache[38] = [
                                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                            ]))])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("form", {
                            onSubmit: _cache[22] || (_cache[22] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                        }, [
                            _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("label", _hoisted_38, [
                                    _cache[39] || (_cache[39] = _createElementVNode("i", { class: "fas fa-tag me-2 text-primary" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('ingredientBase.ingredientBaseName')) + " * ", 1)
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(["form-control", { 'is-valid': (_ctx.formData.name || '').trim().length > 0 }]),
                                    placeholder: _ctx.$t('forms.example') + ' Tomate, Fromage, Jambon...',
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.formData.name) = $event)),
                                    required: ""
                                }, null, 10, _hoisted_39), [
                                    [_vModelText, _ctx.formData.name]
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                    _cache[40] || (_cache[40] = _createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('ingredientBase.ingredientBaseNameHelp')), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("label", _hoisted_42, [
                                    _cache[41] || (_cache[41] = _createElementVNode("i", { class: "fas fa-language me-2 text-primary" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('ingredient.multilingualTranslations')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                        _cache[42] || (_cache[42] = _createElementVNode("label", { class: "form-label" }, "FR", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.translationFormData.fr) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.translationFormData.fr]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_45, [
                                        _cache[43] || (_cache[43] = _createElementVNode("label", { class: "form-label" }, "EN", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.translationFormData.en) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.translationFormData.en]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                        _cache[44] || (_cache[44] = _createElementVNode("label", { class: "form-label" }, "DE", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.translationFormData.de) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.translationFormData.de]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_47, [
                                        _cache[45] || (_cache[45] = _createElementVNode("label", { class: "form-label" }, "IT", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.translationFormData.it) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.translationFormData.it]
                                        ])
                                    ])
                                ]),
                                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "form-text" }, [
                                    _createElementVNode("i", { class: "fas fa-info-circle me-1" }),
                                    _createTextVNode(" Ajoutez les traductions; vides seront ignorées. ")
                                ], -1))
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("label", _hoisted_49, [
                                    _cache[47] || (_cache[47] = _createElementVNode("i", { class: "fas fa-image me-2 text-primary" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('ingredient.ingredientImage')), 1)
                                ]),
                                (_ctx.formData.image_url || _ctx.formData.imageFile)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                        _createElementVNode("div", _hoisted_51, [
                                            _createElementVNode("img", {
                                                src: _ctx.getImagePreview(),
                                                alt: "Aperçu de l'image",
                                                class: "image-preview"
                                            }, null, 8, _hoisted_52),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn-remove-image",
                                                onClick: _cache[12] || (_cache[12] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.removeImage && _ctx.removeImage(...args))),
                                                title: "Supprimer l'image"
                                            }, [...(_cache[48] || (_cache[48] = [
                                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                                ]))])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_53, [
                                    _createElementVNode("div", _hoisted_54, [
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["nav-link", { active: !_ctx.imageUploadMode }]),
                                            onClick: _cache[13] || (_cache[13] = ($event) => (_ctx.imageUploadMode = false)),
                                            type: "button"
                                        }, [...(_cache[49] || (_cache[49] = [
                                                _createElementVNode("i", { class: "fas fa-link me-2" }, null, -1),
                                                _createTextVNode("URL ", -1)
                                            ]))], 2),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["nav-link", { active: _ctx.imageUploadMode }]),
                                            onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.imageUploadMode = true)),
                                            type: "button"
                                        }, [...(_cache[50] || (_cache[50] = [
                                                _createElementVNode("i", { class: "fas fa-upload me-2" }, null, -1),
                                                _createTextVNode("Upload ", -1)
                                            ]))], 2)
                                    ]),
                                    (!_ctx.imageUploadMode)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "url",
                                                class: "form-control",
                                                placeholder: "https://example.com/image.jpg",
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.formData.image_url) = $event)),
                                                onInput: _cache[16] || (_cache[16] = ($event) => (_ctx.formData.imageFile = null))
                                            }, null, 544), [
                                                [_vModelText, _ctx.formData.image_url]
                                            ]),
                                            _cache[51] || (_cache[51] = _createElementVNode("div", { class: "form-text" }, [
                                                _createElementVNode("i", { class: "fas fa-info-circle me-1" }),
                                                _createTextVNode(" Saisissez l'URL complète de l'image ")
                                            ], -1))
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["upload-area", { 'drag-over': _ctx.isDragOver }]),
                                                onDragover: _cache[18] || (_cache[18] = _withModifiers(($event) => (_ctx.isDragOver = true), ["prevent"])),
                                                onDragleave: _cache[19] || (_cache[19] = _withModifiers(($event) => (_ctx.isDragOver = false), ["prevent"])),
                                                onDrop: _cache[20] || (_cache[20] = _withModifiers(
                                                //@ts-ignore
                                                (...args) => (_ctx.handleFileDrop && _ctx.handleFileDrop(...args)), ["prevent"])),
                                                onClick: _cache[21] || (_cache[21] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.openFileDialog && _ctx.openFileDialog(...args)))
                                            }, [
                                                _createElementVNode("input", {
                                                    ref: "fileInput",
                                                    type: "file",
                                                    accept: "image",
                                                    onChange: _cache[17] || (_cache[17] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args))),
                                                    style: { "display": "none" }
                                                }, null, 544),
                                                _cache[52] || (_cache[52] = _createElementVNode("div", { class: "upload-content" }, [
                                                    _createElementVNode("i", { class: "fas fa-cloud-upload-alt upload-icon" }),
                                                    _createElementVNode("p", { class: "upload-text" }, [
                                                        _createTextVNode(" Cliquez pour sélectionner une image"),
                                                        _createElementVNode("br"),
                                                        _createTextVNode(" ou glissez-déposez ici ")
                                                    ]),
                                                    _createElementVNode("small", { class: "upload-hint" }, " Formats acceptés: JPG, PNG, GIF (max 5MB) ")
                                                ], -1))
                                            ], 34)
                                        ]))
                                ])
                            ])
                        ], 32)
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-secondary",
                            onClick: _cache[23] || (_cache[23] =
                                //@ts-ignore
                                (...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                            disabled: _ctx.isLoading
                        }, [...(_cache[53] || (_cache[53] = [
                                _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1),
                                _createTextVNode(" Annuler ", -1)
                            ]))], 8, _hoisted_58),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success",
                            onClick: _cache[24] || (_cache[24] =
                                //@ts-ignore
                                (...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                            disabled: !_ctx.formData.name.trim() || _ctx.isLoading
                        }, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                                    key: 0,
                                    class: "me-2"
                                }))
                                : (_openBlock(), _createElementBlock("i", _hoisted_60)),
                            _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? "Mettre à jour" : "Ajouter l'ingrédient"), 1)
                        ], 8, _hoisted_59)
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                    _cache[56] || (_cache[56] = _createStaticVNode("<div class=\"modal-header\" data-v-9bf047d2><h5 class=\"modal-title\" id=\"confirmModalLabel\" data-v-9bf047d2> Confirmation de suppression </h5><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-9bf047d2></button></div><div class=\"modal-body text-center\" data-v-9bf047d2><i class=\"fas fa-exclamation-triangle warning-icon\" data-v-9bf047d2></i><p class=\"mb-0\" data-v-9bf047d2> Êtes-vous sûr de vouloir supprimer cet ingrédient de base ?<br data-v-9bf047d2>Cette action est irréversible. </p></div>", 2)),
                    _createElementVNode("div", _hoisted_64, [
                        _cache[55] || (_cache[55] = _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            "data-bs-dismiss": "modal"
                        }, [
                            _createElementVNode("i", { class: "fas fa-times me-2" }),
                            _createTextVNode("Annuler ")
                        ], -1)),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[27] || (_cache[27] = ($event) => (_ctx.executeDeleteAction())),
                            "data-bs-dismiss": "modal"
                        }, [...(_cache[54] || (_cache[54] = [
                                _createElementVNode("i", { class: "fas fa-trash-alt me-2" }, null, -1),
                                _createTextVNode("Supprimer ", -1)
                            ]))])
                    ])
                ])
            ])
        ])
    ], 64));
}
